import { AddQBankToQConfigForm } from '@exam-management/qconfig-add-qbank-to-qconfig';
import { useModalNavigation, useParams } from '@exam-management/router';
import { Dialog, DialogTitle, Divider } from '@shared/components';

export default function AddQBankToQConfigModal() {
  const { courseId, qconfigId } = useParams('/exam-courses/:courseId/qconfigs/:qconfigId');
  const { close, current } = useModalNavigation(
    '/exam-courses/:courseId/qconfigs/:qconfigId',
    '/add-qbank-to-qconfig',
    {
      close: {
        params: {
          courseId,
          qconfigId,
        },
      },
    },
  );

  return (
    <Dialog open={current === '/add-qbank-to-qconfig'}>
      <DialogTitle onClose={close}>Add QBank</DialogTitle>
      <Divider />
      <AddQBankToQConfigForm onClose={close} />
    </Dialog>
  );
}
